/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guidevideo_Error_Video_Required1Inputs */

const vi_guidevideo_error_video_required1 = /** @type {(inputs: Guidevideo_Error_Video_Required1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vui lòng chọn video trong Thư viện ảnh`)
};

/**

* @param {Guidevideo_Error_Video_Required1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const guidevideo_error_video_required1 = /** @type {((inputs?: Guidevideo_Error_Video_Required1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guidevideo_Error_Video_Required1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_guidevideo_error_video_required1(inputs)
});
export { guidevideo_error_video_required1 as "guideVideo_error_video_required" }